import { createSlice } from "@reduxjs/toolkit";
import { getCpaClientList } from "./_userAction";
import { getStorageItem } from "../../../../services/storage.service";

const initialState: any = {
  userDetail: {},
  location: {},
  isLogin: false,
  cpaClientlist: [],
  error: null,
  isRealEstate: (() => {
    const storedValue = getStorageItem("isRealEstate") || null;
    return storedValue !== null ? JSON.parse(storedValue) : null;
  })(),
  token: getStorageItem("token") || null,
  has_subscription: false,
  planPermission: null,
};

export const userReducer = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setLogin: (state, action) => {
      state.isLogin = action.payload;
    },
    setUserDetail: (state, action) => {
      state.userDetail = action.payload;
    },
    setLocations: (state, action) => {
      state.location = action.payload
    },
    setIsRealEstate: (state, action) => {
      state.isRealEstate = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setHasSubscription: (state, action) => {
      state.has_subscription = action.payload;
    },
    setPlanPermission: (state, action) => {
      state.planPermission = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch cpa client list
      .addCase(getCpaClientList.pending, (state) => {
        state.error = null;
      })
      .addCase(getCpaClientList.fulfilled, (state, action) => {
        state.cpaClientlist = action.payload?.clients;
      })
      .addCase(getCpaClientList.rejected, (state, action) => {
        state.error = action.payload as string;
      })
  },
});

export const { setLogin, setUserDetail, setLocations, setIsRealEstate, setToken, setHasSubscription, setPlanPermission } = userReducer.actions;
